export default "__VITE_PUBLIC_ASSET__62559382__"